<script>
import {BSGet, BSPost} from "../../js-core/conn/reqs"
import GeneralImage from './img/GeneralImg.svelte'
let bucketIds = []
let selected = {}
export let selectedBucketId

async function getFiles() {
    const ret = await BSGet('tv-owner/user-files')
    if (ret.status !== 200) throw "error getting user files"
    const body = await ret.json()
    bucketIds = body.response.bucketIds
}
async function setSelectedBucketId(bucketId) {
    selectedBucketId = bucketId
    for (let k in selected) selected[k] = false
    selected[bucketId] = true
}
</script>
<div use:getFiles class="row">
    {#each bucketIds as bucketId}
        <div class="col-sm-6">
            <div class="img-wrapper row {selected[bucketId] ? 'selected' :''}">
                <div class="col-12">
                    <a href="#" on:click|preventDefault={(e) => setSelectedBucketId(bucketId)}>
                        <GeneralImage id={bucketId} height=90 />
                    </a>
                </div>
                {#if selected[bucketId]}
                    <div class="col-12">
                        Selected Content
                    </div>
                {/if}
            </div>
        </div>
    {/each}
</div>

<style>
    .img-wrapper {
        padding: 1rem;
        position: relative;
    }
    .selected::before {
        top: 0;
        position: absolute;
        bottom: 0;
        right: 0;
        left: 0;
        content: '';
        background: rgba(112, 112, 112, 0.712);
    }
</style>